var _desc, _defs, _rect, _text, _text2, _rect2, _text3, _text4, _text5, _text6, _rect3, _text7, _path, _rect4, _text8, _text9, _path2, _rect5, _text0, _path3, _rect6, _text1, _text10, _text11, _path4, _text12, _rect7, _text13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcsFargateArchitectureMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 720 1420",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "ECS Fargate \uBC30\uD3EC\xB7\uB85C\uADF8 \uC6B4\uC601 \uAD6C\uC870") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "\uBAA8\uBC14\uC77C\uC6A9 \uC778\uD504\uB77C \uAC1C\uB150\uB3C4. Terraform\uC73C\uB85C \uAD00\uB9AC\uD558\uBA70 CI/CD\uC640 ECR\uB85C Fargate\uC5D0 \uBC30\uD3EC\uD55C\uB2E4. Route53, Public\xB7Internal ALB\uC640 \uC11C\uBE44\uC2A4\uBCC4 Target Group\uC744 \uAC70\uCCD0 \uC694\uCCAD\uC744 \uCC98\uB9AC\uD558\uACE0 \uBE14\uB8E8\xB7\uADF8\uB9B0 \uBC30\uD3EC, \uB864\uBC31, Auto Scaling \uBC0F FireLens \uB85C\uADF8 \uB77C\uC6B0\uD305\uC744 \uAD6C\uC131\uD55C\uB2E4. \uC2E4\uC81C \uC11C\uBE44\uC2A4 \uC218\uC640 \uB124\uD2B8\uC6CC\uD06C \uBC30\uCE58\uB294 \uC0DD\uB7B5\uD588\uB2E4.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 7,
    markerHeight: 7,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L10 5L0 10Z",
    fill: "#1377ad"
  })), /*#__PURE__*/React.createElement("style", null, "\n      text { font-family: Pretendard, \"Apple SD Gothic Neo\", \"Noto Sans KR\", sans-serif; }\n      .title { font-size: 42px; font-weight: 800; fill: #26384b; }\n      .label { font-size: 38px; font-weight: 750; fill: #26384b; }\n      .caption { font-size: 32px; font-weight: 600; fill: #506174; }\n      .accent { fill: #1377ad; }\n      .arrow { fill: none; stroke: #1377ad; stroke-width: 4; marker-end: url(#arrow); }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 1420,
    rx: 32,
    fill: "#fbfcfd"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 70,
    className: "title"
  }, "ECS Fargate \uC6B4\uC601 \uAD6C\uC870")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 118,
    className: "caption"
  }, "Terraform \uAD00\uB9AC \xB7 \uAD6C\uC131 \uAC1C\uB150\uB3C4")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 158,
    width: 640,
    height: 196,
    rx: 24,
    fill: "#f1f5f8"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 205,
    className: "caption"
  }, "\uBC30\uD3EC \uACBD\uB85C")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 259,
    className: "label"
  }, "GitHub Actions / Jenkins")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 315,
    className: "caption"
  }, "ECR \uC774\uBBF8\uC9C0 \u2192 Fargate \uBC30\uD3EC")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 418,
    className: "caption accent"
  }, "\uC694\uCCAD \uD750\uB984")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 448,
    width: 640,
    height: 104,
    rx: 20,
    fill: "#eef8fd",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 513,
    textAnchor: "middle",
    className: "label"
  }, "Route53")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 556V604",
    className: "arrow"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 620,
    width: 640,
    height: 132,
    rx: 20,
    fill: "#eef8fd",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 673,
    textAnchor: "middle",
    className: "label"
  }, "Public / Internal ALB")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 720,
    textAnchor: "middle",
    className: "caption"
  }, "\uC811\uADFC \uACBD\uACC4 \uC720\uC9C0 \xB7 12\uAC1C \u2192 4\uAC1C")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M360 756V804",
    className: "arrow"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 820,
    width: 640,
    height: 104,
    rx: 20,
    fill: "#eef8fd",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 885,
    textAnchor: "middle",
    className: "label"
  }, "\uC11C\uBE44\uC2A4\uBCC4 Target Group")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M360 928V976",
    className: "arrow"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 992,
    width: 640,
    height: 202,
    rx: 24,
    fill: "#eaf6fc",
    stroke: "#dce4ea",
    strokeWidth: 2
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 1052,
    textAnchor: "middle",
    className: "label accent"
  }, "ECS Fargate \xB7 Task")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 1107,
    textAnchor: "middle",
    className: "caption"
  }, "\uBE14\uB8E8/\uADF8\uB9B0 \uBC30\uD3EC \xB7 \uB864\uBC31")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 1156,
    textAnchor: "middle",
    className: "caption"
  }, "Task Auto Scaling")), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M360 1198V1252",
    className: "arrow"
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 390,
    y: 1237,
    className: "caption"
  }, "\uB85C\uADF8")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 1268,
    width: 640,
    height: 104,
    rx: 20,
    fill: "#f1f5f8"
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 360,
    y: 1333,
    textAnchor: "middle",
    className: "label"
  }, "FireLens \xB7 \uB85C\uADF8 \uB77C\uC6B0\uD305")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcsFargateArchitectureMobile);
export default __webpack_public_path__ + "static/media/ecs-fargate-architecture-mobile.d993ec61a9152b98be8cf4857938dee4.svg";
export { ForwardRef as ReactComponent };